import { render, staticRenderFns } from "./AuditLogActionPill.vue?vue&type=template&id=3cef33ab&scoped=true&"
import script from "./AuditLogActionPill.vue?vue&type=script&lang=ts&"
export * from "./AuditLogActionPill.vue?vue&type=script&lang=ts&"
import style0 from "./AuditLogActionPill.vue?vue&type=style&index=0&id=3cef33ab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cef33ab",
  null
  
)

export default component.exports